/* Aster Paris — Trouver ma taille
   Logique (v5) :
   1) Veste, Pantalon et Chemise ont chacun LEUR PROPRE grille taille/poids -> taille,
      calibrée indépendamment. La conversion "veste - 8" (basée sur la numérotation des
      patrons) ne collait pas à la réalité sur certains gabarits (grand + mince) — abandonnée
      partout, y compris pour la chemise désormais.
   2) Si le client saisit ses mesures précises (poitrine/taille/hanches), on ignore les
      grilles et on compare directement ses mesures aux tableaux par catégorie (matchSize).
*/

(function () {
  "use strict";

  // Mesures corporelles (cm) par taille, par catégorie — utilisées uniquement pour le
  // parcours "mesures précises" (saisie manuelle), pas pour l'estimation taille/poids.
  var CATEGORY_DATA = {
    veste: {
      label: { fr: "Veste", en: "Jacket" },
      sizes: [44, 46, 48, 50, 52, 54, 56, 58],
      chest: [[86,90],[90,94],[94,98],[98,102],[102,106],[106,110],[110,114],[114,118]],
      waist: [[74,78],[78,82],[82,86],[86,90],[90,94],[94,98],[98,102],[102,106]],
      primary: "chest"
    },
    pantalon: {
      label: { fr: "Pantalon", en: "Trousers" },
      sizes: [36, 38, 40, 42, 44, 46],
      // AISANCE_PANTALON_TAILLE = 6cm, AISANCE_PANTALON_HANCHE = 8cm (hypothèse à valider)
      waist: [[69,73],[73,77],[77,81],[81,85],[85,89],[89,93]],
      hip: [[87,91],[91,95],[95,99],[99,103],[103,107],[107,111]],
      primary: "waist"
    },
    chemise: {
      label: { fr: "Chemise", en: "Shirt" },
      sizes: [36, 38, 40, 42, 44, 46],
      // AISANCE_CHEMISE_POITRINE = 16cm, AISANCE_CHEMISE_TAILLE = 14cm (hypothèse à valider)
      chest: [[87,91],[91,95],[95,99],[99,103],[103,107],[107,111]],
      waist: [[83,87],[87,91],[91,95],[95,99],[99,103],[103,107]],
      primary: "chest"
    }
  };

  // Grilles taille (cm client) x poids (kg) -> taille de référence, une par catégorie.
  // Colonnes : bandes de taille client. Lignes : bandes de poids client.
  var HEIGHT_BANDS = [[165,172],[173,180],[181,188],[189,196]];
  var WEIGHT_BANDS = [[55,62],[63,70],[71,78],[79,86],[87,94],[95,102],[103,110]];

  // Grille VESTE (échelle 44-58).
  var GRID_VESTE = [
    [44, 44, 46, 46],
    [46, 47, 48, 49],
    [48, 49, 50, 51],
    [50, 51, 52, 52], // (79-86kg, 189-196cm) confirmé 52 le 12/07 — retour client réel
                       // (190cm/85kg -> veste 52 pour un costume).
    [52, 53, 54, 52], // (87-94kg, 189-196cm) ajusté à 52 par cohérence avec la cellule
                       // voisine ci-dessus (retour client 190cm/87kg) — provisoire.
    [54, 55, 56, 57],
    [56, 57, 58, 58]
  ];

  // Grille PANTALON (échelle 36-46), calibrée indépendamment de la veste.
  var GRID_PANTALON = [
    [36, 36, 38, 38],
    [38, 39, 40, 41],
    [40, 41, 42, 43],
    [42, 43, 44, 42], // (79-86kg, 189-196cm) confirmé 42 le 12/07 — retour client réel.
    [44, 45, 46, 42], // (87-94kg, 189-196cm) confirmé 42 le 12/07 — retour client réel
                       // (190cm/87kg -> pantalon 42) — gabarit grand + mince, jambes longues
                       // mais tour de taille modéré : le décrochage vs la cellule voisine (46)
                       // est normal ici.
    [46, 47, 48, 49],
    [48, 49, 50, 50]
  ];

  // Grille CHEMISE (échelle 36-46), calibrée indépendamment de la veste et du pantalon.
  var GRID_CHEMISE = [
    [36, 36, 38, 38],
    [38, 39, 40, 41],
    [40, 41, 42, 43],
    [42, 43, 44, 42], // (79-86kg, 189-196cm) confirmé 42 le 13/07 — retour client réel
                       // (190cm/85kg -> chemise 42, taille L).
    [44, 45, 46, 42], // (87-94kg, 189-196cm) aligné à 42 par cohérence avec la cellule
                       // voisine ci-dessus — provisoire, à confirmer.
    [46, 47, 48, 49],
    [48, 49, 50, 50]
  ];

  function findBandIndex(bands, value) {
    for (var i = 0; i < bands.length; i++) {
      if (value <= bands[i][1] || i === bands.length - 1) return i;
    }
    return bands.length - 1;
  }

  function clampToSizes(sizes, value) {
    return Math.max(sizes[0], Math.min(sizes[sizes.length - 1], value));
  }

  function roundToStep(value, sizes) {
    var rounded = Math.round(value / 2) * 2;
    return clampToSizes(sizes, rounded);
  }

  function fitOffsetFor(fit) {
    return fit === "ajustee" ? -2 : fit === "ample" ? 2 : 0;
  }

  // Taille de référence à partir d'une grille donnée (taille/poids/coupe).
  function referenceFromGrid(grid, heightCm, weightKg, fit) {
    var hIdx = findBandIndex(HEIGHT_BANDS, heightCm);
    var wIdx = findBandIndex(WEIGHT_BANDS, weightKg);
    return grid[wIdx][hIdx] + fitOffsetFor(fit);
  }

  // Trouve la taille dont la tranche corporelle contient (ou est la plus proche de) la mesure donnée.
  function matchSize(category, measurement) {
    var data = CATEGORY_DATA[category];
    var dim = data.primary;
    var ranges = data[dim];
    var best = 0, bestDist = Infinity;
    for (var i = 0; i < ranges.length; i++) {
      var r = ranges[i];
      var dist = measurement < r[0] ? r[0] - measurement : measurement > r[1] ? measurement - r[1] : 0;
      if (dist < bestDist) { bestDist = dist; best = i; }
    }
    var alt = null;
    if (bestDist === 0) {
      if (measurement - ranges[best][0] < 1.5 && best > 0) alt = data.sizes[best - 1];
      else if (ranges[best][1] - measurement < 1.5 && best < ranges.length - 1) alt = data.sizes[best + 1];
    }
    return { size: data.sizes[best], alt: alt };
  }

  function resultFromRef(sizes, ref) {
    var size = roundToStep(ref, sizes);
    var isBetween = ref % 2 !== 0;
    var alt = null;
    if (isBetween) {
      var altSize = roundToStep(ref + 2, sizes);
      if (altSize !== size) alt = altSize;
    }
    return { size: size, alt: alt };
  }

  var GRIDS = { veste: GRID_VESTE, pantalon: GRID_PANTALON, chemise: GRID_CHEMISE };

  function estimate(category, heightCm, weightKg, fit) {
    var data = CATEGORY_DATA[category];
    var ref = referenceFromGrid(GRIDS[category], heightCm, weightKg, fit);
    return resultFromRef(data.sizes, ref);
  }

  function recommend(category, heightCm, weightKg, fit, manual) {
    if (category === "costume") {
      return {
        isComposite: true,
        veste: recommend("veste", heightCm, weightKg, fit, manual),
        pantalon: recommend("pantalon", heightCm, weightKg, fit, manual)
      };
    }
    var data = CATEGORY_DATA[category];
    if (manual && manual[data.primary]) {
      return matchSize(category, manual[data.primary]);
    }
    return estimate(category, heightCm, weightKg, fit);
  }

  function cmFromFtIn(feet, inches) {
    return ((feet || 0) * 12 + (inches || 0)) * 2.54;
  }

  function cmFromInches(inches) {
    return (inches || 0) * 2.54;
  }

  function kgFromLbs(lbs) {
    return (lbs || 0) * 0.45359237;
  }

  window.AsterSizeFinder = {
    CATEGORY_DATA: CATEGORY_DATA,
    recommend: recommend,
    cmFromFtIn: cmFromFtIn,
    cmFromInches: cmFromInches,
    kgFromLbs: kgFromLbs,
    I18N: {
      fr: {
        alertMissing: "Merci de renseigner votre taille et votre poids.",
        togglePreciseOpen: "- Masquer les mesures précises",
        togglePreciseClosed: "+ J'ai mes mesures précises",
        fitNames: { ajustee: "ajustée", regular: "regular", ample: "ample" },
        recommendSingle: function (size, categoryLabel, fitName) {
          return "Nous vous recommandons la taille " + size + " pour cette " + categoryLabel.toLowerCase() + ", en coupe " + fitName + ".";
        },
        recommendComposite: function (fitName) {
          return "Voici les tailles conseillées pour votre costume, en coupe " + fitName + ".";
        },
        altText: function (alt) {
          return "Vous êtes entre deux tailles — le " + alt + " peut aussi vous convenir selon vos préférences.";
        }
      },
      en: {
        alertMissing: "Please enter your height and weight.",
        togglePreciseOpen: "- Hide precise measurements",
        togglePreciseClosed: "+ I have my precise measurements",
        fitNames: { ajustee: "slim", regular: "regular", ample: "relaxed" },
        recommendSingle: function (size, categoryLabel, fitName) {
          return "We recommend size " + size + " for this " + categoryLabel.toLowerCase() + ", in a " + fitName + " fit.";
        },
        recommendComposite: function (fitName) {
          return "Here are the recommended sizes for your suit, in a " + fitName + " fit.";
        },
        altText: function (alt) {
          return "You're between two sizes — " + alt + " could also work depending on your preference.";
        }
      }
    }
  };
})();